import { useAppState } from "../../../contexts/UserContext";
import { useMoodFiltering } from "../../../shared/charts/moodBalance/useMoodFiltering";
import { getLastEndedWeekKey } from "../../../utils/common/weekUtils";
import type { Mood } from "../../../types/models";

export function useHasMoodsInLastEndedWeek(): boolean {
  const { moods } = useAppState();
  const lastEndedWeekKey = getLastEndedWeekKey();
  const filteredMoods = useMoodFiltering(
    (moods || []) as Mood[],
    lastEndedWeekKey
  );
  const hasMoods = filteredMoods.length > 0;

  console.log(
    "[useHasMoodsInLastEndedWeek] lastEndedWeekKey:",
    lastEndedWeekKey,
    "moodsInWeek:",
    filteredMoods.length,
    "hasMoods:",
    hasMoods
  );

  return hasMoods;
}
